"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var checkValidTexture = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url) {
    var response, validTexture;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!url || url.includes('undefined'))) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", null);
        case 2:
          _context.prev = 2;
          _context.next = 5;
          return fetch(url);
        case 5:
          response = _context.sent;
          validTexture = response.ok;
          return _context.abrupt("return", validTexture);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 10]]);
  }));
  return function checkValidTexture(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = checkValidTexture;
exports["default"] = _default;
//# sourceMappingURL=checkValidTexture.js.map